var PopupUpsell = (function() {

   function PopupUpsell(data) {
      this.$popup = null;
      this.data = data;
      this.selectedVariant = this.data[0];

      const upsell = document.getElementById('popup_upsell');

      const variant_title = upsell.querySelector('.popup_upsell-info-text-variant');
      const variant_image = upsell.querySelector('.popup_upsell-info-image');

      const popupUpsell = this;

      function select_color() {
         const prev_selected = upsell.querySelector('.popup_upsell-color.selected');
         prev_selected.classList.remove('selected');

         this.classList.add('selected');

         popupUpsell.selectedVariant = popupUpsell.data[this.dataset.id];
         variant_title.innerHTML = popupUpsell.selectedVariant.title;
         variant_image.src = popupUpsell.selectedVariant.featured_image.src;
      }

      const color_pickers = upsell.querySelectorAll('.popup_upsell-color');
      color_pickers.forEach(picker => picker.addEventListener('click', select_color));

      const first_picker = upsell.querySelector('.popup_upsell-color');
      first_picker.classList.add('selected');
   }

   PopupUpsell.prototype = _.extend(PopupUpsell.prototype, {
      open: function() {
         document.body.style.overflow = 'hidden';

         if (this.$popup)
            this.$popup.close();

         $.magnificPopup.open({
            items: {
               src: $('#popup_upsell'),
               type: 'inline'
            },
            midClick: true,
            showCloseBtn: true,
            mainClass: 'mfp-fade',
            callbacks: {
               close: () => {
                  this.close();
               }
            }
         });

         this.$popup = $.magnificPopup.instance;
      },

      close: function() {
         if (this.$popup) {
            this.$popup.close();
            this.$popup = null;
         }

         document.body.style.overflow = 'auto';
      }
   });

   return PopupUpsell;
})();
